var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.setHeight,
      expression: "setHeight"
    }],
    staticClass: "overflow-auto",
    style: _vm.disabled ? {} : {
      position: 'sticky',
      'max-height': _vm.h,
      top: _vm.top
    }
  }, [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }